export default {
	ATA_REGISTRO_PRECO: { text: 'Ata De Registro De Preço', value: 'ATA_REGISTRO_PRECO', idKey: 'idAta', path: 'atas' },
	PEDIDO_UTILIZACAO: { text: 'Pedido de Utilização', value: 'PEDIDO_UTILIZACAO', idKey: 'idPedido', path: 'pedido' },
	OUTROS: { text: 'Outros', value: 'OUTROS', idKey: 'idAta', path: 'atas' },
	ADESAO: { text: 'Adesão', value: 'ADESAO', idKey: 'idAdesao', path: 'adesao' },
	ADITIVO_APOSTILA: { text: 'Aditivo/Apostila', value: 'ADITIVO_APOSTILA', idKey: 'idAditivoApostila', path: 'atas' },
}
